(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/faq-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/faq-suspension.js');
'use strict';

const FaqSuspension = () => {
  const uttagUrl = svs.core.urlMapping.get('transactionsWithdrawal');
  const kundserviceUrl = svs.core.urlMapping.get('customerServiceContact');
  return React.createElement("div", {
    className: "align-left"
  }, React.createElement("div", {
    className: "f-bold"
  }, "Detta \xE4r Spelpaus"), React.createElement("p", null, "En aktivering av spelpaus pausar dig fr\xE5n spel. Du v\xE4ljer sj\xE4lv vilket/vilka spel samt hur l\xE4nge du vill pausa."), React.createElement("div", {
    className: "f-bold margin-top-2"
  }, "G\xE5r det att h\xE4va Spelpaus?"), React.createElement("p", null, "Nej. Svenska Spel kan inte h\xE4va en aktiverad spelpaus innan den l\xF6pt ut."), React.createElement("div", {
    className: "f-bold margin-top-2"
  }, "N\xE4r kan jag spela igen?"), React.createElement("p", null, "Du kan spela igen n\xE4r pausen l\xF6pt ut. Om du pausat dig 1 \xE5r eller mer s\xE5 m\xE5ste du kontakta Kundservice f\xF6r att kunna spela igen."), React.createElement("div", {
    className: "f-bold margin-top-2"
  }, "Vad h\xE4nder med mitt spelkonto?"), React.createElement("p", null, "Du kan ta ut eventuellt saldo fr\xE5n ditt spelkonto p\xE5", ' ', React.createElement("a", {
    className: "u-text-decoration-underline",
    href: uttagUrl
  }, "uttagssidan.")), React.createElement("div", {
    className: "f-bold margin-top-2"
  }, "Kundservice"), React.createElement("p", {
    className: "margin-bottom-0"
  }, "F\xF6r fr\xE5gor om spelpaus \xE4r du alltid v\xE4lkommen att kontakta Kundservice via", ' ', React.createElement("a", {
    className: "u-text-decoration-underline",
    href: kundserviceUrl
  }, "kontaktsidan"), "."));
};
svs.spelpaus.pages.svsSuspension.components.FaqSuspension = FaqSuspension;

 })(window);